import React, { useState, useEffect } from "react";
import { baseURL } from "../../App";
import "./admin.css";
import axios from "axios";
import Cookies from "js-cookie";

const ContactAdmin = () => {
  const [contactData, setContactData] = useState({
    email: "",
    whatsapp: "",
    linkedin: "",
    _id: null,
  });
  const [allContactData, setAllContactData] = useState([]);
  const API_URL = `${baseURL}/api/contact`;
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const token = Cookies.get("token");

  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await axios.get(API_URL, { withCredentials: true });
        setAllContactData(response.data);
        setContactData(response.data[0] || { email: "", whatsapp: "", linkedin: "", _id: null });
      } catch (err) {
        console.error("Error fetching Contact data:", err);
        setConfirmationMessage("Error fetching data. Please try again later.");
      }
    };
    fetchContactData();
  }, [API_URL]);

  const handleChange = (e) => {
    setContactData({ ...contactData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (event) => {
    const selectedId = event.target.value;
    if (selectedId === "new") {
      setContactData({ email: "", whatsapp: "", linkedin: "", _id: null });
    } else {
      const selectedContact = allContactData.find((contact) => contact._id === selectedId);
      if (selectedContact) {
        setContactData(selectedContact);
      }
    }
  };

  const handleCreate = async () => {
    try {
      const response = await axios.post(API_URL, contactData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });

      setAllContactData([...allContactData, response.data]);
      setConfirmationMessage("Contact information created successfully!");
      setContactData({ email: "", whatsapp: "", linkedin: "", _id: null });
    } catch (error) {
      console.error("Error creating contact info:", error);
      setConfirmationMessage(error?.response?.data?.message || "Error creating data.");
    }
  };

  const handleUpdate = async () => {
    try {
      await axios.put(`${API_URL}/${contactData._id}`, contactData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setConfirmationMessage("Contact information updated successfully!");
      setAllContactData((prevData) =>
        prevData.map((item) => (item._id === contactData._id ? contactData : item))
      );
    } catch (error) {
      console.error("Error updating contact info:", error);
      setConfirmationMessage(error?.response?.data?.message || "Error updating data.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!contactData._id) {
      handleCreate();
    } else {
      handleUpdate();
    }
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_URL}/${contactData._id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setConfirmationMessage("Data deleted successfully!");
      setAllContactData((prev) => prev.filter((item) => item._id !== contactData._id));
      setContactData({ email: "", whatsapp: "", linkedin: "", _id: null });
    } catch (err) {
      console.error("Error deleting Contact data:", err);
      setConfirmationMessage(err?.response?.data?.message || "Error deleting data.");
    }
  };

  return (
    <div className="admin-section">
      <h2>Contact Management</h2>

      <select
        className="select-item"
        onChange={handleSelectChange}
        value={contactData?._id || "new"}
      >
        <option className="select-item__option" value="new">
          New
        </option>
        {allContactData.map((contact) => (
          <option className="select-item__option" key={contact._id} value={contact._id}>
            {contact.email}
          </option>
        ))}
      </select>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={contactData.email}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="whatsapp"
          placeholder="WhatsApp"
          value={contactData.whatsapp}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="linkedin"
          placeholder="LinkedIn"
          value={contactData.linkedin}
          onChange={handleChange}
          required
        />
        <div className="btn-actions">
          <button className="btn btnPrimary" type="submit">
            Save
          </button>

          <button
            className="btn btnDanger"
            type="button"
            onClick={() => {
              if (window.confirm("Are you sure you want to delete this entry?")) {
                handleDelete();
              }
            }}
            disabled={!contactData._id}
          >
            Delete
          </button>
        </div>
      </form>

      {confirmationMessage && <div className="confirmation-message">{confirmationMessage}</div>}
    </div>
  );
};

export default ContactAdmin;
